// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__kgJhC","col":"styles_col__LRT_5"};